import { MutationTree, Mutation } from 'vuex';
import { IJob, IState } from './state';
import { ActionPayload, IValuePayload } from './actions';

type MutationHandler<PayloadType> = (state: IState, payload: ActionPayload<PayloadType>) => any;

const setStateMutation: MutationHandler<IState> = (state, { payload }) => {
	Object.assign(state, payload);
}
const setSearchQueryMutation: MutationHandler<string> = (state, { payload }) => {
	Object.assign(state, {
		query: payload
	});
}
const resetPageMutation: MutationHandler<undefined> = (state, { payload }) => {
	Object.assign(state, {
		page: 0,
	});
}
const toggleValueMutation: MutationHandler<IValuePayload> = (state, { payload }) => {

	// If there is a filter with the same name that comes from payload
	const filter = state.categoryFilters.find(f => f.name === payload.name);
	if(filter) {

		// Value = the value that filter and payload shares
		// Change selected on that/thoes value/values
		const value = filter.values.find(f => f.value === payload.value)
		if(value) {
			Object.assign(value, {
				selected: payload.selected,
			})
		}
		

	}
}
const setCurrentPageMutation: MutationHandler<number> = (state, { payload }) => {
	Object.assign(state, { 
		page: payload
	});
}
const setPagesMutation: MutationHandler<number> = (state, { payload }) => {
	Object.assign(state, {pages: payload});
}
const setJobsMutation: MutationHandler<IJob[]> = (state, { payload }) => {
	Object.assign(state, {
		jobs: payload,
	});
}

const setTotalMutation: MutationHandler<number> = (state, { payload }) => {
	Object.assign(state, {
		total: payload,
	});
}
const clearFiltersMutation: MutationHandler<number> = (state, { payload }) => {
	state.categoryFilters.forEach(cf => {
		cf.values.forEach(v => Object.assign(v, {selected: false}))
	})
}

const setSortMutation: MutationHandler<string> = (state, { payload }) => {
	state.sort.forEach(s => {
		if(s.name === payload) {
			Object.assign(s, { active: true })
		} else {
			Object.assign(s, { active: false })
		}
	});
}
const mutations: MutationTree<IState> = {
	setState: setStateMutation,
	toggleValue: toggleValueMutation,
	resetPage: resetPageMutation,
	setJobs: setJobsMutation,
	setTotal: setTotalMutation,
	setSearchQuery: setSearchQueryMutation,
	setCurrentPage: setCurrentPageMutation,
	setPages: setPagesMutation,
	clearFilters: clearFiltersMutation,
	setSort: setSortMutation,
}

export default mutations
